import { Component, ChangeDetectionStrategy, HostListener, ChangeDetectorRef, ViewChild, ElementRef, AfterViewChecked, OnInit } from '@angular/core';
import { debounce, isEmpty } from 'lodash';
import { UserStorage } from '../../user/user-storage';
import { UrlBuilder } from '../../core';
import { first, map } from 'rxjs/operators';
import { User } from '../../user';
import { Title } from '@angular/platform-browser';
import { ActivityLogger } from '../../activities/activity-logger';
import { ActivatedRoute } from '@angular/router';
import { routeData } from '../../shared/route-helpers';
import { WorkspaceDrawerBehavior, drawerBehaviorKey } from '../../layout/workspace-drawer-behavior';
import { UserPreferencesStorage } from '../../user-preferences/user-preferences-storage';

@Component({
    selector: 'sm-workspace-level-layout',
    template: require('./sm-workspace-level-layout.component.html'),
    styles: [require('./sm-workspace-level-layout.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SMWorkspaceLevelLayoutComponent implements AfterViewChecked, OnInit {
    public get isDrawerCollapsed(): boolean {
        return this.collapseDrawer;
    }

    @ViewChild('asideDrawer')
    public asideDrawer: ElementRef;

    @ViewChild('divSiteLayout')
    public divSiteLayout: ElementRef;

    public user$ = this.userStorage.currentUser;

    private readonly debounceCollapseDrawer: () => void;
    private readonly screenSizeThreshold = 1300;

    private manualDrawer = false;
    private collapseDrawer = false;

    constructor(
        private route: ActivatedRoute,
        private userStorage: UserStorage,
        changeDetectorRef: ChangeDetectorRef,
        private readonly urlBuilder: UrlBuilder,
        private title: Title,
        private userPreferencesStorage: UserPreferencesStorage,
        activityLogger: ActivityLogger
    ) {
        this.debounceCollapseDrawer = debounce(
            () => {
                this.calculateCollapsing();
                changeDetectorRef.markForCheck();
            },
            200);

        this.restoreDrawerBehavior();
        this.calculateCollapsing();
    }

    public async ngOnInit() {
        const currentUser = await this.userStorage.currentUser
            .pipe(
                map(u => u),
                first())
            .toPromise();
    }

    public ngAfterViewChecked() {
        this.changeMdlTooltipsParent();
    }

    public onCollapseButton() {
        this.manualDrawer = true;
        this.collapseDrawer = !this.collapseDrawer;

        this.saveDrawerBehavior();
    }

    public getDefaultUrlByRole(user: User) {

        this.urlBuilder.esa().sampletracking().url();
    }

    @HostListener('window:resize')
    public onWindowResize() {
        this.calculateCollapsingOnResize();
    }

    private calculateCollapsingOnResize() {
        if (this.manualDrawer && this.collapseDrawer) {
            return;
        }

        this.resetManualCollapse();
        this.debounceCollapseDrawer();
    }

    private resetManualCollapse() {
        if (window.innerWidth > this.screenSizeThreshold) {
            this.manualDrawer = false;
        }
    }

    private calculateCollapsing() {
        if (this.manualDrawer) {
            return;
        }

        this.collapseDrawer = window.innerWidth < this.screenSizeThreshold;
    }

    // mdl-tooltips shouldn't be placed within <aside> to avoid z-index issue with cropping absolute-positioned elements.
    private changeMdlTooltipsParent() {
        const mdlTooltips = (this.asideDrawer.nativeElement as HTMLElement).querySelectorAll('mdl-tooltip');

        if (!isEmpty(mdlTooltips)) {
            for (let i = 0; i < mdlTooltips.length; i++) {
                const mdlTooltip = mdlTooltips.item(i);
                (this.divSiteLayout.nativeElement as HTMLElement).appendChild(mdlTooltip);
            }
        }
    }

    private restoreDrawerBehavior() {
        const behavior = this.route.snapshot.data[routeData.drawerBehavior] as WorkspaceDrawerBehavior;

        if (behavior && behavior.manualCollapsed) {
            this.manualDrawer = true;
            this.collapseDrawer = true;
        }
    }

    private saveDrawerBehavior() {
        const behavior: WorkspaceDrawerBehavior = { manualCollapsed: this.manualDrawer && this.collapseDrawer };
        const item = JSON.stringify(behavior);

        this.userPreferencesStorage.set(drawerBehaviorKey, item);
    }
   
}
